var _linearGradient, _linearGradient2, _linearGradient3, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSkype(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "48pt",
    viewBox: "0 0 48 48",
    width: "48pt",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "a"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00c4ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83888397938,
    stopColor: "#0072ff"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    gradientTransform: "matrix(43.01 0 0 42.58 2.495 2.71)",
    gradientUnits: "userSpaceOnUse",
    x1: 0,
    x2: 0.907488,
    xlinkHref: "#a",
    y1: 0.5,
    y2: 0.920078
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    gradientTransform: "matrix(16.667 0 0 25 15.667 11.5)",
    gradientUnits: "userSpaceOnUse",
    x1: 0,
    x2: 0.907488,
    xlinkHref: "#a",
    y1: 0.5,
    y2: 0.920078
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m40.495 29.69.41-2.15c.27-1.18.4-2.39.4-3.6 0-2.88-.78-5.7-2.27-8.17-1.46-2.41-3.54-4.39-6.03-5.72-2.48-1.32-5.25-2.01-8.06-2-1.08 0-2.17.1-3.24.3l-1.39.34-1.92-.98c-1.19-.66-2.53-1-3.89-1h-.02c-2.11 0-4.15.82-5.66 2.3-1.48 1.45-2.32 3.44-2.33 5.51v.01c0 1.06.22 2.11.64 3.08l.8 1.83-.2 1.04c-.26 1.19-.39 2.4-.39 3.61-.01 2.88.78 5.7 2.26 8.17 1.47 2.41 3.55 4.38 6.03 5.72 2.48 1.32 5.25 2.01 8.06 2 1.09 0 2.18-.1 3.24-.3l1.83-.35 1.73 1c1.08.63 2.32.96 3.57.96h.01c1.97-.01 3.85-.81 5.22-2.23 1.42-1.48 2.21-3.45 2.21-5.5v-.02c0-1.06-.6-2.87-1.01-3.85zm4.164-.587.156-.693c.32-1.46.49-2.96.49-4.47 0-3.61-.98-7.15-2.85-10.24-1.83-3.03-4.44-5.5-7.56-7.18-3.06-1.63-6.48-2.48-9.95-2.47-1.33 0-2.66.12-3.97.37l-.192.035-.468-.255c-1.78-.98-3.78-1.49-5.81-1.49h-.01c-3.16 0-6.2 1.23-8.46 3.44-2.26 2.2-3.53 5.21-3.54 8.36v.02c0 1.61.33 3.21.98 4.69l.297.68c-.287 1.377-.427 2.778-.427 4.18-.01 3.61.98 7.16 2.84 10.25 1.84 3.02 4.45 5.5 7.57 7.17 3.06 1.64 6.48 2.49 9.95 2.48 1.33 0 2.66-.12 3.97-.37l.384-.071.436.251c1.69.98 3.61 1.5 5.56 1.5h.01.01.01c3.05-.01 5.97-1.26 8.09-3.46 2.14-2.22 3.33-5.19 3.33-8.27v-.01c0-1.524-.285-3.03-.846-4.447z",
    fill: "url(#b)",
    fillRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m24 15.667c2.258 0 4.167 1.431 4.167 3.125 0 1.15.933 2.083 2.083 2.083s2.083-.933 2.083-2.083c0-4.021-3.738-7.292-8.333-7.292s-8.333 3.271-8.333 7.292 3.738 7.291 8.333 7.291c2.258 0 4.167 1.432 4.167 3.125 0 1.694-1.909 3.125-4.167 3.125s-4.167-1.431-4.167-3.125c0-1.15-.933-2.083-2.083-2.083s-2.083.933-2.083 2.083c0 4.021 3.738 7.292 8.333 7.292s8.333-3.271 8.333-7.292-3.738-7.291-8.333-7.291c-2.258 0-4.167-1.432-4.167-3.125 0-1.694 1.909-3.125 4.167-3.125z",
    fill: "url(#c)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSkype);
export default __webpack_public_path__ + "static/media/skype.bef369976390e5182e5c6f7e7596d27d.svg";
export { ForwardRef as ReactComponent };